import {API, Storage} from 'aws-amplify';
import moment from "moment";
import LogRocket from "logrocket";


function getMyInitiReport(params) {
    let myInitDb = {
        body:
            {
                "businessUnitID": 2236,
                "type": "MONTHLY",
                "competencyDate": "2020-12-01",
                "typeDocument": params.type
            }
        ,
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };

    return myInitDb;
}


function getMyInitiDocumentDb(params) {
    let skip = 0;
    if (params.hasOwnProperty('skip'))
        skip = params.skip * 20;

    let myInitDb = {
        body: {
            database: process.env.REACT_APP_DATABASE,
            collection: 'reports',
            command: 'find',
            skip: skip,
            limit: 50,
            sort: [["statusChangeDate", -1]],
            "query": {},
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };

    if (typeof params.form !== 'undefined') {
        let name = typeof params.form.name == 'undefined' ? "" : params.form.name;
        let origin = typeof params.form.origin == 'undefined' ? "automatico" : params.form.origin;

        let dateFrom = typeof params.form.dateFrom == 'undefined' ? moment().startOf('month').toISOString() : moment(params.form.dateFrom).startOf('month').toISOString();
        let dateTo = typeof params.form.dateTo == 'undefined' ? moment().endOf('month').toISOString() : moment(params.form.dateTo).endOf('month').toISOString();

        myInitDb = {
            body: {
                database: process.env.REACT_APP_DATABASE,
                collection: 'reports',
                command: 'find',
                skip: skip,
                limit: 50,
                sort: [["statusChangeDate", -1]],
                "query": {
                    "name": {"$regex": name, "$options": "i"},
                    "origin": {"$regex": origin, "$options": "i"},
                    dateRef: {"$gte": {"$date": dateFrom}, "$lte": {"$date": dateTo}}
                },
            },
            headers: {
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Origin': 'http://localhost:3000',
                'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                drtoken: localStorage.getItem('token')
            }
        };
    }

    return myInitDb;
}


function getMyInitiDocumentDbFinancial(params) {
    let dateFrom = "";
    let dateTo = "";
    console.log(params.date);
    if (params.type == "yy") {
        dateFrom = params.date == "" ? moment().startOf('year').format() : moment(params.date).startOf('year').format();
        dateTo = params.date == "" ? moment().endOf('year').format() : moment(params.date).endOf('year').format();
    } else {
        dateFrom = params.date == "" ? moment().startOf('month').format() : moment(params.date).startOf('month').format();
        dateTo = params.date == "" ? moment().endOf('month').format() : moment(params.date).endOf('month').format();
    }


    let myInitDb = {
        body: {
            database: 'db-unilever-silver'/*process.env.REACT_APP_DATABASE*/,
            collection: 'financial_reports',
            command: 'find',
            limit: 2,
            sort: [["_id", -1]],
            "query": {
                "businessUnitID": parseInt(params.report),
                "type": params.type == 'yy' ? "ANNUAL" : "MONTHLY",
                dateRef: {"$gte": {"$date": dateFrom}, "$lte": {"$date": dateTo}}
            },
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };

    return myInitDb;
}


function getHeadersDownload(originalFile, originalName, bucket) {
    let myInitDb = {
        body: {
            bucket: bucket,
            key: originalFile
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            'Access-Control-Request-Headers': 'access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,authorization,content-type,drtoken,x-amz-date,x-amz-security-token',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function getMyInitUpload(client, key, oname) {
    let body = {
        clientName: client,
        originalName: oname,
        srcBucket: process.env.REACT_APP_SRC_BUCKET,
        user: localStorage.getItem('tbClientes'),
        srcKey: key
    };

    let myInit = {
        body: body, // replace this with attributes you need
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };

    return myInit;
}

function newNameFile(filename) {
    let ext = filename.split('.').pop();
    let dt = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });

    return uuid + '.' + ext;
}

export default {
    getReports: (params = {}) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDb(params)).then(response => {
            return response.response;
        }).catch(err => {
            LogRocket.captureException(err);
        }),


    getReportsFinancial: (params = {}) =>
        API.post('dr', '/report', getMyInitiReport(params)).then(response => {
            return response;
        }).catch(err => {
            LogRocket.captureException(err);
            alert('Ocorreu um erro.');
        }),

    getReportsFinancialMongoDb: (params = {}) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDbFinancial(params)).then(response => {
            return response.response;
        }).catch(err => {
            LogRocket.captureException(err);
        }),

    downloadReports: (originalFile, originalName, bucket) =>
        API.post('dr', '/download', getHeadersDownload(originalFile, originalName, bucket))
            .then(response => {
                const a = document.createElement('a');
                a.setAttribute('hidden', '');
                a.setAttribute('href', response.presigned_url);
                a.setAttribute('download', 'Teste');
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            })
            .catch(err => {
                LogRocket.captureException(err);
                alert('Ocorreu um erro ao fazer o download.');
            }),
};
